import React, { Component } from 'react';
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';
import { DiagramComponent, SymbolPaletteComponent, Node } from "@syncfusion/ej2-react-diagrams";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Prompt } from "react-router";

let diagramInstance;


class GraphicalRep extends Component {

    constructor() {
        super();

        this.state = {
            hideDoYouSave: false,
            isFlowEnd: false,
            showLoader: false,
            slotValueType: [],
            showSlotPopup: false,
            slotNamePresent: false,
            showMltPopup: false,
            showApiPopup: false,
            toBeSaved: false

        };
        this.nodes = [];
        this.slotNameList = [];
        this.connectors = [];
        this.flowshapes = [
            {
                id: "START", height: 40, width: 130,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:20px;background-color:rgb(0, 200, 83);height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/start_dwf.png" style="width:30px;height:30px;margin-top:2px" />&nbsp;&nbsp;START</div>'
                }
            },
            {
                id: "EXIT", height: 40, width: 130,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:20px;height:100%;background-color:rgb(244, 67, 54);text-align:center;border:1.5px solid #696969"><img src="assets/images/exit_dwf.png" style="width:30px;height:30px" />EXIT</div>'
                }
            },
            {
                id: "Decision", height: 60, width: 60,
                shape: {
                    type: 'HTML',
                    content: '<div style="transform:rotate(45deg);height:100%;text-align:center;border:1.5px solid #696969;z-index:-1"><div class="diamond-shape-content"><img src="assets/images/decision_dwf.png" style="width:30px;height:30px;" />IF</div></div>'
                },
                annotations: [
                    {
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap",
                            visibility: "visible"
                        },
                    },
                ],
            },
            {
                id: "CALL_API", height: 60, width: 130,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/call_api_dwf.png" style="width:40px;height:40px;" />&nbsp;&nbsp;CALL_API</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    },
                ],
            },
            {
                id: "GET", height: 60, width: 100,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/get_dwf.png" style="width:40px;height:40px;" />&nbsp;&nbsp;GET</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "SPEAK", height: 60, width: 110,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/speak_dwf.png" style="width:40px;height:40px;" />&nbsp;&nbsp;SPEAK</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "SET", height: 60, width: 100,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/set_dwf.png" style="width:40px;height:40px;" />&nbsp;&nbsp;SET</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },

            {
                id: "DO", height: 60, width: 90,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/do_dwf.png" style="width:40px;height:40px;" />&nbsp;&nbsp;DO</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "SPEAK_4_EACH", height: 60, width: 180,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/speak_4_each.png" style="width:70px;height:30px;" />&nbsp;&nbsp;SPEAK_4_EACH</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "WAIT", height: 60, width: 90,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/wait_dwf.png" style="width:40px;height:40px;" />&nbsp;&nbsp;WAIT</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "EXPECT", height: 60, width: 110,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/expect_dwf.png" style="width:40px;height:40px;" />&nbsp;&nbsp;EXPECT</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "TAKE_PAYMENT", height: 60, width: 160,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/take_payment_dwf.png" style="width:40px;height:40px;" />&nbsp;&nbsp;TAKE_PAYMENT</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "COMMAND", height: 60, width: 130,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/command_dwf.png" style="width:40px;height:40px;" />&nbsp;&nbsp;COMMAND</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "ESCALATE", height: 60, width: 130,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/escalate.png" style="width:40px;height:40px;" />&nbsp;&nbsp;ESCALATE</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "COMMAND_N_TEXT", height: 60, width: 200,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/command_n_text_dwf.png" style="width:70px;height:30px;" />&nbsp;&nbsp;COMMAND_N_TEXT</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "EMAIL", height: 60, width: 100,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/email.png" style="width:40px;height:40px;" />&nbsp;&nbsp;EMAIL</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "SAVE_2_SHEET", height: 60, width: 160,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/save-to-sheet.png" style="width:40px;height:40px;" />&nbsp;&nbsp;SAVE_2_SHEET</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            },
            {
                id: "SAVE_2_THIS_SHEET", height: 60, width: 160,
                shape: {
                    type: 'HTML',
                    content: '<div style="border-radius:10px;height:100%;text-align:center;border:1.5px solid #696969"><img src="assets/images/save-to-sheet.png" style="width:40px;height:40px;" />&nbsp;&nbsp;SAVE_2_THIS_SHEET</div>'
                },
                backgroundColor: "rgb(147, 210, 250)",
                style: {
                    fill: 'rgb(147, 210, 250)',
                    strokeColor: 'white'
                },
                annotations: [
                    {
                        margin: {
                            top: 10
                        },
                        verticalAlignment: "Top",
                        style: {
                            fontSize: 13,
                            fontFamily: "Arial",
                            textWrapping: "Wrap"
                        },
                    }
                ],
            }
        ];
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchData();
        }, 300);

        var thisController = this;

        document.addEventListener("projectChanged", function (event) {
            thisController.goBack();
        });



    }
    goBack = () => {
        this.props.history.push({
            pathname: "/projectmgmt/nlutab/dsm/dsm-graphs",
            state: { goBackToFaq: true, pageNum: this.props.location.state.pageNum }
        });
    }


    fetchGraphicalDataApis = () => {
        let GraphicalRepController = this;
        $.ajax({
            url: "/api/task-api",
            async: false,
            method: 'GET',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            data: { projectId: localStorage.getItem('currentProjectId') },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        var apiNameElement = document.getElementById("apiNames");
                        if (apiNameElement != null) {
                            apiNameElement.innerHTML = null;
                            for (var i = 0; i < res.result.length; i++) {
                                apiNameElement.innerHTML = apiNameElement.innerHTML + "<label style=color:#282a65;font-size:16px>" + res.result[i].name + "</label><br />"
                            }
                            GraphicalRepController.state.showApiPopup = true;
                            GraphicalRepController.setState(GraphicalRepController.state);
                        }
                    } else {
                        GraphicalRepController.notifyNoPopupDataFound("Oops!you have not added Api for your project");
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    notifyNoPopupDataFound = (result) => {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;{result}</b>, {
            position: "bottom-center",

        });
    }

    fetchMltNames = () => {
        var GraphicalRepController = this;
        $.ajax({
            url: "/api/mlt",
            async: false,
            method: 'GET',

            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },
            data: {
                projectId: localStorage.getItem('currentProjectId'),
                language: "ENGLISH"
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        var sortedMltList = res.result.sort((a, b) => a.code.localeCompare(b.code));
                        var mltNameElement = document.getElementById("mltNames");
                        if (mltNameElement != null) {
                            mltNameElement.innerHTML = null;
                            for (var i = 0; i < sortedMltList.length; i++) {
                                mltNameElement.innerHTML = mltNameElement.innerHTML + "<label style=color:#282a65;font-size:16px>" + sortedMltList[i].code + "</label><br />"
                            }
                            GraphicalRepController.state.showMltPopup = true;
                            GraphicalRepController.setState(GraphicalRepController.state);
                        }
                    } else {
                        GraphicalRepController.notifyNoPopupDataFound("Oops!you have not added Mlt for your project");
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    getSlotNames = () => {
        let transitionController = this;
        let intentId = localStorage.getItem("intentId");
        $.ajax({
            url: "/api/slots",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: {
                intentId: intentId
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        transitionController.state.emptyDataRecord = {};
                        var slotNameElement = document.getElementById("slotNames");
                        if (slotNameElement != null) {
                            slotNameElement.innerHTML = null;
                            for (var i = 0; i < res.result.length; i++) {
                                var labelElement = document.createElement("input");
                                labelElement.setAttribute("style", "color:#282a65;font-size:16px;border-bottom:none;width:auto;cursor:default");
                                labelElement.readOnly = true;
                                labelElement.value = res.result[i].name;
                                slotNameElement.appendChild(labelElement);
                                slotNameElement.appendChild(document.createElement("b"))

                                var buttonElement = document.createElement("button");
                                buttonElement.innerHTML = "Copy";
                                buttonElement.className = "bubble";
                                var clickAssignment = function () {
                                    var myLabel = labelElement;
                                    buttonElement.onclick = function () {
                                        myLabel.select();
                                        myLabel.setSelectionRange(0, 99999); /*For mobile devices*/

                                        /* Copy the text inside the text field */
                                        document.execCommand("copy");
                                        return false;
                                    }
                                };
                                clickAssignment();
                                slotNameElement.appendChild(buttonElement);
                                slotNameElement.appendChild(document.createElement("br"))
                            }
                            transitionController.state.showSlotPopup = true;
                            transitionController.setState(transitionController.state);
                        }
                    } else {
                        transitionController.notifyNoPopupDataFound("Oops!you have not added Slot for your project");
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        })
    }

    notifySuccess = (response) => {
        toast.dismiss();
        toast(<b><img src="./assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{response}</b>,
            {
                position: "top-center",
            });
    }

    fetchData = () => {
        let transitionController = this;
        let data = {
            dwfId: transitionController.props.location.state.dstId
        }
        $.ajax({
            url: "/api/dialog-state-json",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    localStorage.setItem("savedDiagrams", document.getElementById("diagram").innerText);

                    transitionController.setState({ hideDoYouSave: false })
                    transitionController.setState(transitionController);
                    var json = res.result.DialogStateJson;
                    if (json != null) {
                        const blob = new Blob([json], { type: 'application/json' });
                        let reader = new FileReader();
                        reader.readAsText(blob);
                        reader.onloadend = transitionController.loadDiagram;
                    }
                } else {
                    transitionController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    loadDiagram = (event) => {
        diagramInstance.loadDiagram(event.target.result);
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }


    backButtonClickEvent = () => {
        this.props.history.push({
            pathname: "/projectmgmt/nlutab/dsm/dsm-graphs",
            state: { goBackToDsm: true }
        });
    }

    saveFlowChartApi(dialogStateJson) {
        var dwfId = this.props.location.state.dstId;
        var transitionController = this;
        var requestJson = {
            id: dwfId,
            dialogStateJson: dialogStateJson
        };
        $.ajax({
            url: "/api/dialog-state-json",
            async: false,
            method: 'PATCH',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(requestJson),
            processData: false,
            success: function (res) {
                if (res.success === true) {
                    transitionController.notifySuccess("Work flow Saved Successfully");
                    transitionController.fetchData();
                    transitionController.state.toBeSaved = false;
                    transitionController.state.hideDoYouSave = false;
                    transitionController.setState(transitionController);

                } else {
                    transitionController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        })
    }

    getDiagramInstance = () => {
        const dialogStateJson = diagramInstance.saveDiagram()
        this.saveFlowChartApi(dialogStateJson)
    }
    detectChangeEvent = () => {
        var localComp = this;
        localComp.setState({ toBeSaved: true })
    }
    render() {
        let nodes = []
        let connectorSymbols = [
            {
                id: "Straight",
                type: "Straight",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 60, y: 60 },
                targetDecorator: { shape: "Arrow" },
                style: { strokeWidth: 1 }
            },
            {
                id: "NONE",
                type: "Straight",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 60, y: 60 },
                targetDecorator: { shape: "Arrow" },
                style: { strokeWidth: 1 },
                annotations: [
                    {
                        content: "NONE",
                    }
                ]
            },
            {
                id: "ANY",
                type: "Straight",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 60, y: 60 },
                targetDecorator: { shape: "Arrow" },
                style: { strokeWidth: 1 },
                annotations: [
                    {
                        content: "ANY"
                    }
                ]
            },
            {
                id: "USER_DONT_KNOW",
                type: "Straight",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 120, y: 60 },
                targetDecorator: { shape: "Arrow" },
                style: { strokeWidth: 1 },
                annotations: [
                    {
                        content: "USER_DONT_KNOW"
                    }
                ],
            },
            {
                id: "PRESENT",
                type: "Straight",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 60, y: 60 },
                targetDecorator: { shape: "Arrow" },
                style: { strokeWidth: 1 },
                annotations: [
                    {
                        content: "PRESENT"
                    }
                ]
            },
            {
                id: "VALUE",
                type: "Straight",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 60, y: 60 },
                targetDecorator: { shape: "Arrow" },
                style: { strokeWidth: 1 },
                annotations: [
                    {
                        content: "VALUE"
                    }
                ]
            },
            {
                id: "REGEX",
                type: "Straight",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 60, y: 60 },
                targetDecorator: { shape: "Arrow" },
                style: { strokeWidth: 1 },
                annotations: [
                    {
                        content: "REGEX"
                    }
                ]
            },
        ];

        let connectors = [];

        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ marginLeft: '400px' }}
                />
                <div style={{ display: !this.state.showLoader ? 'block' : 'none' }}>
                    <link rel="stylesheet" href="assets/css/buttonForm.css" />
                    {/* for toaster */}
                    <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="./assets/css/react-table-height.css" />

                    {/* for Combobox styling */}
                    <link rel="stylesheet" href="./assets/css/combobox-style.css" />

                    {/* for dialog component */}
                    <link href="./assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="./assets/css/screenResolution.css" rel="stylesheet" />


                    <ToastContainer className="Toast-at-center" />
                    <div className="container-fluid">
                        <div className="row" style={{
                            zIndex: '100', position: 'fixed', width: '88%',
                            backgroundColor: 'rgb(249, 249, 251)', marginTop: '-1%'
                        }}>
                            <div className="col-sm-2">
                                <img className="cursor-change" src="./assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer', marginTop: '10%' }}
                                    onClick={this.backButtonClickEvent}
                                />
                            </div>
                            <div className="col-sm-3">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    textAlign: 'center', marginTop: '18px'
                                }}>Work flow for the skill {this.props.location.state.skillName}</h6>
                            </div>
                            <div className="col-sm-7" Align='right'>
                                <button type="button" className="btn action-button"
                                    onClick={this.getSlotNames}>View Names of Slots</button>

                                <button type="button" className="btn action-button"
                                    onClick={this.fetchMltNames}>View Names of Multi Lingual Text</button>

                                <button type="button" className="btn action-button"
                                    onClick={this.fetchGraphicalDataApis}>View Names of Apis</button>

                                {/* Refresh Page */}
                                <button className="btn action-button"
                                    onClick={this.getDiagramInstance} title="Save">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="content" style={{ marginTop: '4%' }}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                    <div className="card">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <SymbolPaletteComponent id="symbolpalette"
                                                    expandMode="Multiple" palettes={[
                                                        {
                                                            id: "flow",
                                                            symbols: this.flowshapes,
                                                            iconCss: "e-diagram-icons1 e-diagram-flow",
                                                            title: "Dialog Functions"
                                                        },
                                                        {
                                                            id: "connectors",
                                                            symbols: connectorSymbols,
                                                            iconCss: "e-diagram-icons1 e-diagram-connector",
                                                            title: "Connectors"
                                                        },
                                                    ]}



                                                />
                                            </div>
                                            <div className="col-lg-8">
                                                <DiagramComponent
                                                    ref={diagram => (diagramInstance = diagram)}
                                                    id="diagram"
                                                    width={"100%"}
                                                    height={"1000px"}
                                                    nodes={nodes}
                                                    connectors={connectors}
                                                    drop={this.detectChangeEvent}
                                                    positionChange={this.detectChangeEvent}
                                                />
                                                <Prompt
                                                    when={this.state.toBeSaved}
                                                    message="Do you want to leave the page without saving your changes?"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Slot Popup */}
                    <div className="modal" style={{ display: this.state.showSlotPopup ? 'block' : 'none' }}>
                        <div className="modal-dialog" id="center-aligned-password-modal">
                            <div className="modal-content" style={{ height: "auto", width: "500px" }}>
                                <div className="modal-header noBorder" style={{ marginBottom: "5px", marginLeft: "-1%", fontSize: "16px" }}><b>Slot names for the skill {this.props.location.state.skillName}</b>
                                    <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={() => this.setState({ showSlotPopup: false })}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form ref={(el) => this.myFormRef = el}>
                                        <div id="slotNames" className="row">
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Mlt Popup */}
                    <div className="modal" style={{ display: this.state.showMltPopup ? 'block' : 'none' }}>
                        <div className="modal-dialog" id="center-aligned-password-modal">
                            <div className="modal-content" style={{ height: "auto", width: "500px" }}>
                                <div className="modal-header noBorder" style={{ fontSize: "16px", marginBottom: "5px" }}><b>Names of Multi Lingual Texts</b>
                                    <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={() => this.setState({ showMltPopup: false })}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form ref={(el) => this.myFormRef = el}>
                                        <div id="mltNames" style={{ overflowY: "scroll" }}>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Api Popup */}
                    <div className="modal" style={{ display: this.state.showApiPopup ? 'block' : 'none' }}>
                        <div className="modal-dialog" id="center-aligned-password-modal">
                            <div className="modal-content" style={{ height: "auto", width: "500px" }}>
                                <div className="modal-header noBorder" style={{ fontSize: "16px", marginBottom: "5px" }}><b>Names of Apis</b>
                                    <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={() => this.setState({ showApiPopup: false })}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form ref={(el) => this.myFormRef = el}>
                                        <div id="apiNames" style={{ overflowY: "scroll" }}>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>



                </div >
            </div >

        )
    }
}
export default GraphicalRep;



// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/transition/GraphicalRep.js